/**
 * Determines whether the current route should use the full-width app layout (no max-w constraint).
 *
 * Policy: Default to full width everywhere to keep table/record views consistent and avoid
 * "squeezed" layouts when new routes are introduced.
 */
export function isFullWidthRoute(_pathname: string): boolean {
  return true;
}
